<script setup>
</script>

<template>
  <div id="kt_app_footer" class="app-footer">
    <div
      class="app-container container-xxl d-flex flex-row flex-stack py-3"
    >
      <div class="text-dark">
        <span class="text-muted fw-semibold me-1">2025&copy;</span>
        <a
          href="#"
          target="_blank"
          class="text-gray-800 text-hover-primary"
          >Tusacan</a
        >
      </div>
      <ul class="menu menu-gray-600 menu-hover-primary fw-semibold">
        <li class="menu-item">
          <a
            href="#"
            target="_blank"
            class="menu-link px-2"
            >Yardım</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>